import React from 'react';
import T from 'prop-types';

const StateRenewalSubmitted = ({ email }) => (
  <div className="press-register-status press-register-status--success">
    <div className="press-register-status__icon press-register-status__icon--success">
      <i className="hicon-check-thin" />
    </div>
    <h1 className="press-register-status__title">Renewal request submitted</h1>
    <p className="press-register-status__subtitle">
      We received your renewal request for {email}. You&apos;ll receive an email once it&apos;s been reviewed.
    </p>
  </div>
);

StateRenewalSubmitted.propTypes = {
  email: T.string,
};

StateRenewalSubmitted.defaultProps = {
  email: '',
};

export default StateRenewalSubmitted;
